export default __webpack_public_path__ + "static/media/Lower_lake_Bhopal.79b8cc3a.jpg";